import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import { c as classNames } from '../../shared/bind-d9144132.js';
import { getPaddingClasses } from '../../utils/padding.js';
import { getSizingClassName, getSizingStyle } from '../../utils/sizing.js';
import { jsx } from 'react/jsx-runtime';
import Item from './Item/Item.js';

var styles = {
  "unit-base": "4",
  "list--legacy": "web_ui__List__list--legacy",
  "no-trailing-divider": "web_ui__List__no-trailing-divider",
  "tight": "web_ui__List__tight",
  "narrow": "web_ui__List__narrow",
  "default": "web_ui__List__default",
  "wide": "web_ui__List__wide",
  "inline": "web_ui__List__inline",
  "gap-none": "web_ui__List__gap-none",
  "gap-x-small": "web_ui__List__gap-x-small",
  "gap-small": "web_ui__List__gap-small",
  "gap-regular": "web_ui__List__gap-regular",
  "gap-medium": "web_ui__List__gap-medium",
  "gap-large": "web_ui__List__gap-large",
  "gap-larger": "web_ui__List__gap-larger",
  "gap-x-large": "web_ui__List__gap-x-large",
  "gap-x-larger": "web_ui__List__gap-x-larger",
  "gap-x2-large": "web_ui__List__gap-x2-large",
  "list": "web_ui__List__list",
  "width-parent": "web_ui__List__width-parent",
  "width-content": "web_ui__List__width-content",
  "width-custom": "web_ui__List__width-custom",
  "height-parent": "web_ui__List__height-parent",
  "height-content": "web_ui__List__height-content",
  "height-custom": "web_ui__List__height-custom",
  "scroll": "web_ui__List__scroll",
  "direction-row": "web_ui__List__direction-row",
  "direction-column": "web_ui__List__direction-column",
  "divider-between": "web_ui__List__divider-between",
  "show-trailing-divider": "web_ui__List__show-trailing-divider",
  "show-leading-divider": "web_ui__List__show-leading-divider",
  "list--p-none": "web_ui__List__list--p-none",
  "list--pt-none": "web_ui__List__list--pt-none",
  "list--pr-none": "web_ui__List__list--pr-none",
  "list--pb-none": "web_ui__List__list--pb-none",
  "list--pl-none": "web_ui__List__list--pl-none",
  "list--px-none": "web_ui__List__list--px-none",
  "list--py-none": "web_ui__List__list--py-none",
  "list--p-x-small": "web_ui__List__list--p-x-small",
  "list--pt-x-small": "web_ui__List__list--pt-x-small",
  "list--pr-x-small": "web_ui__List__list--pr-x-small",
  "list--pb-x-small": "web_ui__List__list--pb-x-small",
  "list--pl-x-small": "web_ui__List__list--pl-x-small",
  "list--px-x-small": "web_ui__List__list--px-x-small",
  "list--py-x-small": "web_ui__List__list--py-x-small",
  "list--p-small": "web_ui__List__list--p-small",
  "list--pt-small": "web_ui__List__list--pt-small",
  "list--pr-small": "web_ui__List__list--pr-small",
  "list--pb-small": "web_ui__List__list--pb-small",
  "list--pl-small": "web_ui__List__list--pl-small",
  "list--px-small": "web_ui__List__list--px-small",
  "list--py-small": "web_ui__List__list--py-small",
  "list--p-regular": "web_ui__List__list--p-regular",
  "list--pt-regular": "web_ui__List__list--pt-regular",
  "list--pr-regular": "web_ui__List__list--pr-regular",
  "list--pb-regular": "web_ui__List__list--pb-regular",
  "list--pl-regular": "web_ui__List__list--pl-regular",
  "list--px-regular": "web_ui__List__list--px-regular",
  "list--py-regular": "web_ui__List__list--py-regular",
  "list--p-medium": "web_ui__List__list--p-medium",
  "list--pt-medium": "web_ui__List__list--pt-medium",
  "list--pr-medium": "web_ui__List__list--pr-medium",
  "list--pb-medium": "web_ui__List__list--pb-medium",
  "list--pl-medium": "web_ui__List__list--pl-medium",
  "list--px-medium": "web_ui__List__list--px-medium",
  "list--py-medium": "web_ui__List__list--py-medium",
  "list--p-large": "web_ui__List__list--p-large",
  "list--pt-large": "web_ui__List__list--pt-large",
  "list--pr-large": "web_ui__List__list--pr-large",
  "list--pb-large": "web_ui__List__list--pb-large",
  "list--pl-large": "web_ui__List__list--pl-large",
  "list--px-large": "web_ui__List__list--px-large",
  "list--py-large": "web_ui__List__list--py-large",
  "list--p-larger": "web_ui__List__list--p-larger",
  "list--pt-larger": "web_ui__List__list--pt-larger",
  "list--pr-larger": "web_ui__List__list--pr-larger",
  "list--pb-larger": "web_ui__List__list--pb-larger",
  "list--pl-larger": "web_ui__List__list--pl-larger",
  "list--px-larger": "web_ui__List__list--px-larger",
  "list--py-larger": "web_ui__List__list--py-larger",
  "list--p-x-large": "web_ui__List__list--p-x-large",
  "list--pt-x-large": "web_ui__List__list--pt-x-large",
  "list--pr-x-large": "web_ui__List__list--pr-x-large",
  "list--pb-x-large": "web_ui__List__list--pb-x-large",
  "list--pl-x-large": "web_ui__List__list--pl-x-large",
  "list--px-x-large": "web_ui__List__list--px-x-large",
  "list--py-x-large": "web_ui__List__list--py-x-large",
  "list--p-x-larger": "web_ui__List__list--p-x-larger",
  "list--pt-x-larger": "web_ui__List__list--pt-x-larger",
  "list--pr-x-larger": "web_ui__List__list--pr-x-larger",
  "list--pb-x-larger": "web_ui__List__list--pb-x-larger",
  "list--pl-x-larger": "web_ui__List__list--pl-x-larger",
  "list--px-x-larger": "web_ui__List__list--px-x-larger",
  "list--py-x-larger": "web_ui__List__list--py-x-larger",
  "list--p-x2-large": "web_ui__List__list--p-x2-large",
  "list--pt-x2-large": "web_ui__List__list--pt-x2-large",
  "list--pr-x2-large": "web_ui__List__list--pr-x2-large",
  "list--pb-x2-large": "web_ui__List__list--pb-x2-large",
  "list--pl-x2-large": "web_ui__List__list--pl-x2-large",
  "list--px-x2-large": "web_ui__List__list--px-x2-large",
  "list--py-x2-large": "web_ui__List__list--py-x2-large"
};

var Size = /*#__PURE__*/function (Size) {
  Size["Default"] = "default";
  Size["Tight"] = "tight";
  Size["Narrow"] = "narrow";
  Size["Wide"] = "wide";
  return Size;
}(Size || {});
var List = function List(_ref) {
  var padding = _ref.padding,
    paddingTop = _ref.paddingTop,
    paddingRight = _ref.paddingRight,
    paddingBottom = _ref.paddingBottom,
    paddingLeft = _ref.paddingLeft,
    paddingHorizontal = _ref.paddingHorizontal,
    paddingVertical = _ref.paddingVertical,
    _ref$gapSize = _ref.gapSize,
    gapSize = _ref$gapSize === void 0 ? 'regular' : _ref$gapSize,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'parent' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 'parent' : _ref$height,
    direction = _ref.direction,
    _ref$scroll = _ref.scroll,
    scroll = _ref$scroll === void 0 ? false : _ref$scroll,
    _ref$showStartDivider = _ref.showStartDivider,
    showStartDivider = _ref$showStartDivider === void 0 ? false : _ref$showStartDivider,
    _ref$showEndDivider = _ref.showEndDivider,
    showEndDivider = _ref$showEndDivider === void 0 ? false : _ref$showEndDivider,
    _ref$dividerBetween = _ref.dividerBetween,
    dividerBetween = _ref$dividerBetween === void 0 ? false : _ref$dividerBetween,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? Size.Default : _ref$size,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$noTrailingDivide = _ref.noTrailingDivider,
    noTrailingDivider = _ref$noTrailingDivide === void 0 ? false : _ref$noTrailingDivide,
    children = _ref.children,
    testId = _ref.testId,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'legacy' : _ref$mode;
  var css = classNames.bind(styles);
  var isModern = mode === 'modern';

  // Dev-only guidance for mixed usage
  if (process.env.NODE_ENV !== 'production') {
    if (!isModern) {
      var usedNewProps = padding !== undefined || paddingTop !== undefined || paddingRight !== undefined || paddingBottom !== undefined || paddingLeft !== undefined || paddingHorizontal !== undefined || paddingVertical !== undefined || gapSize !== 'regular' || width !== 'parent' || height !== 'parent' || direction !== undefined || scroll !== false || showStartDivider !== false || showEndDivider !== false || dividerBetween !== false;
      if (usedNewProps) {
        // eslint-disable-next-line no-console
        console.warn('[List] New API props are ignored in legacy mode. Use `mode="modern"` to enable them.');
      }
    } else if (size !== Size.Default || inline !== false || noTrailingDivider !== false) {
      // eslint-disable-next-line no-console
      console.warn('[List] Legacy props (`size`, `inline`, `noTrailingDivider`) are ignored in modern mode.');
    }
  }

  // Modern-only computations
  var sizingClass = isModern ? getSizingClassName(styles, width, height) : '';
  var style = isModern ? getSizingStyle('list', width, height) : undefined;
  var paddingClass = isModern ? getPaddingClasses(styles, 'list', {
    padding: padding,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingX: paddingHorizontal,
    paddingY: paddingVertical
  }) : '';
  var gapClass = isModern ? styles["gap-".concat(gapSize)] : '';
  var computedDirection = isModern ? direction : undefined;
  var listClass = css(paddingClass, sizingClass, gapClass, styles.list, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles['show-trailing-divider'], isModern && showEndDivider), styles['show-leading-divider'], isModern && showStartDivider), styles['direction-row'], isModern && computedDirection === 'horizontal'), styles['direction-column'], isModern && computedDirection !== 'horizontal'), styles['divider-between'], isModern && dividerBetween), styles.scroll, isModern && scroll), styles['list--legacy'], !isModern), styles.inline, !isModern && inline), styles['no-trailing-divider'], !isModern && noTrailingDivider));
  var sizeClass = isModern ? undefined : size;
  return /*#__PURE__*/jsx("ul", {
    className: css(listClass, sizeClass),
    "data-testid": testId,
    style: style,
    children: children
  });
};
List.Item = Item;
List.Size = Size;

export { List as default };
//# sourceMappingURL=List.js.map
